import React, { useState, useRef, useEffect } from 'react';
import '../../styles/WorkWithUs.css';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import Modal from './Modal';
import useDragToScroll from '../../hooks/useDragToScroll';

function ClientTestimonial() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activePopup, setActivePopup] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const scrollRef = useRef();
  useDragToScroll(scrollRef);
  const testimonials = [
    {
      id: 1,
      quote: `"Simon is the most honest, diligent, professional, and ethical salesperson I have ever encountered, and I would recommend him to anyone."`,
      author: 'Mr Ho Jong Chek',
    },
    {
      id: 2,
      quote: `"Jen is very sincere and enthusiastic in what she does, providing clear information and a well-crafted listing that attracted several interested tenants within two weeks, leading to a speedy deal!"`,
      author: 'Ms Marilyn Ng',
    },
    {
      id: 3,
      quote: `"Jen is very considerate. She responds to our demands when viewing the premises and negotiating with the agent of the landlord. Moreover, she is a patient agent and explains in detail to us about various statements in the contract and 
      helps us to resolve any issues in paying rent, communicating with the utility provider, etc."`,
      author: 'Ms Wang Xinyi',
    },
    {
      id: 4,
      quote: `"Jen is very helpful and understanding. She makes the process easier to move to my new house. She made every documents related to my rent very clear and understandable."`,
      author: 'Mr Badiul Alam',
    },
    {
      id: 5,
      quote: `"Simon has that perfect balance of knowledge, drive and enthusiasm that will get the job done for his clients.
      It would be hard to envision someone doing a better job than Simon ."`,
      author: 'Mr Ching Chik Seng',
    },
    {
      id: 6,
      quote: `"Jen was fair, transparent, and went above and beyond to ensure a smooth process, making this potentially complex transaction remarkably straightforward."`,
      author: 'Mr Micah Wang',
    },
    {
      id: 7,
      quote: `"Simon’s professionalism, strong network, and ethical approach helped us secure countless viewings and successfully sell our home at a price we were delighted with. We would gladly recommend him to anyone."`,
      author: 'Mr Ho Jong Chek',
    },
    {
      id: 8,
      quote: `"Simon went above and beyond our expectations, demonstrating exceptional commitment and tenacity to make our lease happen. His knowledge, dedication, and professionalism were truly a blessing, and I would recommend his services to anyone."`,
      author: 'Ms Venus Zhang',
    },
    {
      id: 9,
      quote: `"Jen is very professional in carrying out the assigned work, She was acutely sensitive to understanding me needs and took immediate steps in the realisation of my expectations. She is punctual, friendly, equitable, and her communication skill is effective."`,
      author: 'Mr Ram S Naidu',
    },
    {
      id: 10,
      quote: `"Jen was very engaging and helpful throughout my journey of finding suitable housing. She's highly proactive, listens to my needs and catered to it very well; which in turn, led to my immediate decision."`,
      author: 'Ms Millie L',
    },
    {
      id: 11,
      quote: `"Simon is a true professional—patient, knowledgeable, and always willing to go the extra mile. His dedication and responsiveness, even late at night, ensured a smooth transaction for our family. We would gladly engage him again and recommend his services to our friends and relatives."`,
      author: 'Mr Tim Kek',
    },
    {
      id: 12,
      quote: `"Simon has a great attitude, and the after-sales service you provided was way beyond the call of duty. I have no hesitation in regarding you as my business partner in any real estate matters and would rate you as my FIRST-CHOICE salesperson."`,
      author: 'Mr Tan Kheng Chye',
    },
  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handlePopup = (id) => {
    setActivePopup(id === activePopup ? null : id);
  };

  const visibleTestimonials = () => {
    if (isMobile) return testimonials;
    const result = [];
    for (let i = 0; i < 3; i++) {
      result.push(testimonials[(currentIndex + i) % testimonials.length]);
    }
    return result;
  };

  return (
    <section className='innerSection'>
      <h2>What Our Clients Say</h2>
      <div className="testimonialSlider" ref={scrollRef}>
        {!isMobile && (
          <button className="arrowBtn left" onClick={handlePrev}>
            <ChevronLeft />
          </button>
        )}

        <div className="testimonialCards">
          {visibleTestimonials().map((testimonial) => (
            <div
              key={testimonial.id}
              className="testimonialCard"
              onClick={() => handlePopup(testimonial.id)}
            >
              <div className="quoteMark">“</div>
              <p className="previewQuote">
                {testimonial.quote.length > 150
                  ? testimonial.quote.slice(0, 150) + '...'
                  : testimonial.quote}
              </p>
              <p className="author">– {testimonial.author}</p>
            </div>
          ))}
        </div>

        {!isMobile && (
          <button className="arrowBtn right" onClick={handleNext}>
            <ChevronRight />
          </button>
        )}
      </div>

      {activePopup && (
        <Modal onClose={() => setActivePopup(null)}>
          <div className="quoteMark">“</div>
          <p>{testimonials.find(t => t.id === activePopup).quote}</p>
          <p className="author">– {testimonials.find(t => t.id === activePopup).author}</p>
        </Modal>
      )}
    </section>
  );
}

export default ClientTestimonial;
